import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = {
  key: 0,
  class: "col"
}
const _hoisted_3 = {
  key: 1,
  class: "col md:col-6"
}
const _hoisted_4 = {
  key: 2,
  class: "col md:col-6"
}
const _hoisted_5 = {
  key: 3,
  class: "col md:col-6"
}
const _hoisted_6 = {
  key: 4,
  class: "col md:col-6"
}
const _hoisted_7 = {
  key: 5,
  class: "col md:col-6"
}
const _hoisted_8 = {
  key: 6,
  class: "col md:col-6"
}
const _hoisted_9 = {
  key: 7,
  class: "col md:col-6"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = {
  key: 8,
  class: "col md:col-6"
}
const _hoisted_12 = {
  key: 9,
  class: "col md:col-6"
}
const _hoisted_13 = { class: "col md:col-6" }
const _hoisted_14 = {
  key: 10,
  class: "col md:col-6"
}
const _hoisted_15 = {
  key: 11,
  class: "col md:col-6"
}
const _hoisted_16 = { class: "col md:col-6" }
const _hoisted_17 = {
  key: 12,
  class: "col md:col-12"
}
const _hoisted_18 = {
  key: 0,
  class: "col md:col-12"
}
const _hoisted_19 = { class: "col md:col-12" }
const _hoisted_20 = { class: "subtitle" }
const _hoisted_21 = { class: "col md:col-12 tags-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_FormQuestionText = _resolveComponent("FormQuestionText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormQuestions = _resolveComponent("FormQuestions")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Tags = _resolveComponent("Tags")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
    errors: _ctx.errorModel,
    "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errorModel) = $event)),
    valid: _ctx.valid,
    "onUpdate:valid": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valid) = $event)),
    submitCheck: _ctx.reValidate,
    "onUpdate:submitCheck": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reValidate) = $event)),
    schema: _ctx.schema
  }, {
    default: _withCtx(({ handleInputChange, handleDateUpdate }) => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.hiddenUserFields.includes('title'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_Select, {
                value: _ctx.model.title,
                error: _ctx.errorModel['title'],
                items: _ctx.titleSelectOptions,
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete ? 'on' : 'off',
                onChange: handleInputChange,
                label: "form.title",
                name: "title",
                id: "title",
                customClass: _ctx.customClass('title')
              }, null, 8, ["value", "error", "items", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.getFormQuestion('firstName'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.firstName,
                error: _ctx.errorModel['firstName'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.first-name",
                name: "firstName",
                id: "firstName",
                customClass: _ctx.customClass('firstName')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_FormQuestionText, {
                formQuestion: _ctx.getFormQuestion('firstName'),
                errorsRef: _ctx.errorsRef,
                readonly: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                userResponse: _ctx.userResponses[_ctx.getFormQuestion('firstName')?.id ?? 0],
                onDoChange: ($event: any) => (_ctx.handleValidatedDoChange($event, handleInputChange))
              }, null, 8, ["formQuestion", "errorsRef", "readonly", "autocomplete", "userResponse", "onDoChange"])
            ])),
        (
            !_ctx.hiddenUserFields.includes('middleName') &&
            !_ctx.getFormQuestion('middleName')
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.middleName,
                error: _ctx.errorModel['middleName'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.middle-name",
                name: "middleName",
                id: "middleName",
                customClass: _ctx.customClass('middleName')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_FormQuestionText, {
                formQuestion: _ctx.getFormQuestion('middleName'),
                errorsRef: _ctx.errorsRef,
                readonly: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                userResponse: 
              _ctx.userResponses[_ctx.getFormQuestion('middleName')?.id ?? 0]
            ,
                onDoChange: ($event: any) => (_ctx.handleValidatedDoChange($event, handleInputChange))
              }, null, 8, ["formQuestion", "errorsRef", "readonly", "autocomplete", "userResponse", "onDoChange"])
            ])),
        (!_ctx.getFormQuestion('surname'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.surname,
                error: _ctx.errorModel['surname'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.surname",
                name: "surname",
                id: "surname",
                customClass: _ctx.customClass('surname')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_FormQuestionText, {
                formQuestion: _ctx.getFormQuestion('surname'),
                errorsRef: _ctx.errorsRef,
                readonly: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                userResponse: _ctx.userResponses[_ctx.getFormQuestion('surname')?.id ?? 0],
                onDoChange: ($event: any) => (_ctx.handleValidatedDoChange($event, handleInputChange))
              }, null, 8, ["formQuestion", "errorsRef", "readonly", "autocomplete", "userResponse", "onDoChange"])
            ])),
        (!_ctx.hiddenUserFields.includes('preferredName'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.preferredName,
                error: _ctx.errorModel['preferredName'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.preferred-name",
                name: "preferredName",
                id: "preferredName",
                customClass: _ctx.customClass('preferredName')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FormInput, {
            value: _ctx.model.email,
            error: _ctx.errorModel['email'],
            disabled: _ctx.readonly || _ctx.config?.isMe,
            autocomplete: _ctx.autocomplete,
            onChange: handleInputChange,
            label: "form.primary-email-address",
            name: "email",
            id: "email",
            customClass: _ctx.customClass('email')
          }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
        ]),
        (
            !_ctx.hiddenUserFields.includes('gender') &&
            !_ctx.getFormQuestion('genderSelect')
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_Select, {
                value: _ctx.model.genderId,
                items: _ctx.genderSelectOptions,
                error: _ctx.errorModel['genderId'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete ? 'on' : 'off',
                onChange: handleInputChange,
                label: "form.gender",
                name: "genderId",
                id: "genderId",
                customClass: _ctx.customClass('genderId')
              }, null, 8, ["value", "items", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hiddenUserFields.includes('maritialStatus'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.maritalStatus,
                error: _ctx.errorModel['maritalStatus'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.marital-status",
                name: "maritalStatus",
                id: "maritalStatus",
                customClass: _ctx.customClass('maritalStatus')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_DatePicker, {
            value: _ctx.model.dob,
            error: _ctx.errorModel['dob'],
            disabled: _ctx.readonly,
            onChange: handleDateUpdate,
            label: "form.date-of-birth",
            name: "dob",
            id: "dob",
            customClass: _ctx.customClass('dob')
          }, null, 8, ["value", "error", "disabled", "onChange", "customClass"])
        ]),
        (!_ctx.hiddenUserFields.includes('placeOfBirth'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.placeOfBirth,
                error: _ctx.errorModel['placeOfBirth'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.place-of-birth",
                name: "placeOfBirth",
                id: "placeOfBirth",
                customClass: _ctx.customClass('placeOfBirth')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hiddenUserFields.includes('nationality'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_Select, {
                value: _ctx.model.nationality,
                items: _ctx.nationalityOptions,
                error: _ctx.errorModel['nationality'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete ? 'on' : 'off',
                onChange: handleInputChange,
                label: "form.nationality",
                name: "nationality",
                id: "nationality",
                customClass: _ctx.customClass('nationality')
              }, null, 8, ["value", "items", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Select, {
            value: _ctx.model.preferredLanguageId,
            items: _ctx.languageSelectOptions,
            error: _ctx.errorModel['preferredLanguageId'],
            disabled: _ctx.readonly,
            autocomplete: _ctx.autocomplete ? 'on' : 'off',
            onChange: handleInputChange,
            label: "form.language",
            name: "preferredLanguageId",
            id: "preferredLanguageId",
            icon: "globe",
            customClass: _ctx.customClass('preferredLanguageId')
          }, null, 8, ["value", "items", "error", "disabled", "autocomplete", "onChange", "customClass"])
        ]),
        (!_ctx.hiddenUserFields.includes('secondaryEmail'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_FormInput, {
                value: _ctx.model.secondaryEmail,
                error: _ctx.errorModel['secondaryEmail'],
                disabled: _ctx.readonly,
                autocomplete: _ctx.autocomplete,
                onChange: handleInputChange,
                label: "form.secondary-email-address",
                name: "secondaryEmail",
                id: "secondaryEmail",
                customClass: _ctx.customClass('secondaryEmail')
              }, null, 8, ["value", "error", "disabled", "autocomplete", "onChange", "customClass"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_FormQuestions, {
          formQuestions: _ctx.formQuestions.filter(fq => !_ctx.ignoredFormFields.includes(fq.fieldReference as string)),
          userResponses: _ctx.userResponses,
          readonly: _ctx.readonly,
          autocomplete: _ctx.autocomplete,
          errorsRef: _ctx.errorsRef,
          onDoChange: ($event: any) => (_ctx.handleValidatedDoChange($event, handleInputChange)),
          onChoiceChange: ($event: any) => (_ctx.handleValidatedChoiceChange($event, handleInputChange)),
          onCheckboxChange: ($event: any) => (
            _ctx.handleValidatedCheckboxChange($event, handleInputChange)
          )
        }, null, 8, ["formQuestions", "userResponses", "readonly", "autocomplete", "errorsRef", "onDoChange", "onChoiceChange", "onCheckboxChange"]),
        (_ctx.additionalFields?.personal)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 13 }, _renderList(Object.keys(
              _ctx.additionalFields?.personal
            ), (additionalField, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col md:col-6",
                key: index
              }, [
                _createVNode(_component_FormInput, {
                  value: _ctx.additionalFields.personal[additionalField],
                  error: '',
                  disabled: _ctx.readonly,
                  autocomplete: _ctx.autocomplete,
                  onChange: _ctx.handleAdditionalFieldChange,
                  label: 
                additionalField.charAt(0).toUpperCase() +
                additionalField.slice(1)
              ,
                  name: additionalField,
                  id: additionalField,
                  customClass: _ctx.customClass(additionalField)
                }, null, 8, ["value", "disabled", "autocomplete", "onChange", "label", "name", "id", "customClass"])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.config?.isMe && _ctx.config?.admin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, [
                _createVNode(_component_TranslatedText, { path: "tags.title" })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Tags, {
                onTagsChanged: _ctx.handleTagsChanged,
                user: _ctx.model,
                editable: true
              }, null, 8, ["onTagsChanged", "user"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "errors", "valid", "submitCheck", "schema"]))
}